import { ReactNode } from 'react';
import { Region } from '../utils/commonInterfaces';

let currentRegion: Region | undefined;

interface RegionWrapperProps {
  region: Region;
  children: ReactNode;
}

export const setRegion = (region?: Region) => {
  currentRegion = region;
};

export const getRegion = () => currentRegion;

export const RegionWrapper = ({ region, children }: RegionWrapperProps) => {
  setRegion(region);
  return <>{children}</>;
};
